'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:flight:getLinkman');
}

var _invoke = require('../invoke');

/**
 * 获取联系人
 *
 * @memberof flight
 * @static
 * @name getLinkman
 * @param {int} id 默认为 '', 
 * @return {Promise}
 * @example
 * hbnb.flight.getLinkman('').then(function(data) {
 *     data = {
           id: 'id is number',
 *         name: 'name is string',
 *         mobile: 'mobile is string',
 *         email: 'mobile is string',
 *     }
 * });
 */
module.exports = function(id) {
    var p = new Promise(function(resolve, reject) {
        _invoke('flight', 'get_linkman', {
            id: id,
            is_international: is_international,
            callback: function(date) {
                resolve(date);
            }
        });
    });
    return p;
};




//////////////////
// WEBPACK FOOTER
// ./~/@hfe/hbnb/flight/get-linkman.js
// module id = 290
// module chunks = 4